export default "__VITE_ASSET__C4DSefcL__"